import(/* webpackMode: "eager" */ "/vercel/path0/src/app/iletisim/page.tsx");
